import { useMemo } from 'react';
import { LazadaStandaloneAuthResultBody } from 'services/api/admin';
import ErrorResult from './ErrorResult';
import SuccessResult, { SuccessResultProps } from './SuccessResult';

export interface AuthResultProps extends SuccessResultProps {
  result: LazadaStandaloneAuthResultBody;
  onNeedHelp: () => void;
}

const AuthResult = (props: AuthResultProps) => {
  const { result, onFinish, onRestart, onNeedHelp, isConfigService, onConfigService } = props;
  const comp = useMemo(() => {
    if (result.isSuccess) {
      return (
        <SuccessResult
          onFinish={onFinish}
          onRestart={onRestart}
          count={result.successCount}
          isConfigService={isConfigService}
          onConfigService={onConfigService}
        />
      );
    }
    return <ErrorResult error={result.errorMsg} onRestart={onRestart} onNeedHelp={onNeedHelp} />;
  }, [
    isConfigService,
    onConfigService,
    onFinish,
    onNeedHelp,
    onRestart,
    result.errorMsg,
    result.isSuccess,
    result.successCount,
  ]);
  return comp;
};
export default AuthResult;
